var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard \\u2013 2",
    clipPath: "url(#clip-Artboard_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 250,
    height: 250,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(63 76)",
    fill: "none",
    stroke: "#808080",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 98,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 116,
    height: 90,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Gym_2160472",
    transform: "translate(83.771 104.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M83.083,29.743h-5.5V25.62A4.123,4.123,0,0,0,73.463,21.5H70.714a4.076,4.076,0,0,0-1.374.253V20.123A4.123,4.123,0,0,0,65.217,16H62.468a4.123,4.123,0,0,0-4.123,4.123v9.62H28.111V21.5a4.123,4.123,0,0,0-4.123-4.123H21.24A4.123,4.123,0,0,0,17.117,21.5v1.627a4.076,4.076,0,0,0-1.374-.253H12.994a4.123,4.123,0,0,0-4.123,4.123v2.749h-5.5A1.374,1.374,0,0,0,2,31.117V44.86a1.374,1.374,0,0,0,1.374,1.374h5.5v4.123a4.123,4.123,0,0,0,4.123,4.123h2.749a4.076,4.076,0,0,0,1.374-.253v.253A4.123,4.123,0,0,0,21.24,58.6h2.749a4.123,4.123,0,0,0,4.123-4.123V46.234H58.346v6.871a4.123,4.123,0,0,0,4.123,4.123h2.749a4.123,4.123,0,0,0,4.123-4.123v-.253a4.076,4.076,0,0,0,1.374.253h2.749a4.123,4.123,0,0,0,4.123-4.123V46.234h5.5a1.374,1.374,0,0,0,1.374-1.374V31.117A1.374,1.374,0,0,0,83.083,29.743ZM4.749,43.486V32.491H8.871V43.486Zm10.994,8.246H12.994a1.374,1.374,0,0,1-1.374-1.374V26.994a1.374,1.374,0,0,1,1.374-1.374h2.749a1.374,1.374,0,0,1,1.374,1.374V50.357A1.374,1.374,0,0,1,15.743,51.731Zm9.62,2.749a1.374,1.374,0,0,1-1.374,1.374H21.24a1.374,1.374,0,0,1-1.374-1.374V21.5a1.374,1.374,0,0,1,1.374-1.374h2.749A1.374,1.374,0,0,1,25.363,21.5Zm2.749-10.994V32.491H58.346V43.486Zm38.48,9.62a1.374,1.374,0,0,1-1.374,1.374H62.468a1.374,1.374,0,0,1-1.374-1.374V20.123a1.374,1.374,0,0,1,1.374-1.374h2.749a1.374,1.374,0,0,1,1.374,1.374Zm8.246-4.123a1.374,1.374,0,0,1-1.374,1.374H70.714a1.374,1.374,0,0,1-1.374-1.374V25.62a1.374,1.374,0,0,1,1.374-1.374h2.749a1.374,1.374,0,0,1,1.374,1.374Zm6.871-5.5H77.586V32.491h4.123Z",
    transform: "translate(-2 -16)",
    fill: "#808080"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard);
export default __webpack_public_path__ + "static/media/Artboard.7fce2cc935bb20737d63abea49f2b46a.svg";
export { ForwardRef as ReactComponent };